<template>
    <div class="cursor" id="cursor"><div class="dot"></div></div>
</template>

<script>
export default {
  name: 'cursor',
  mounted() {
    let cursor = document.getElementById('cursor');

    /*
    document.body.addEventListener('mouseenter', () => {
      document.getElementById('cursor').classList.remove('cursor-inactive')
      document.getElementById('cursor').classList.add('cursor')
    })
    document.body.addEventListener('mouseleave', () => {
      document.getElementById('cursor').classList.remove('cursor')
      document.getElementById('cursor').classList.add('cursor-inactive')
    }) */

    setTimeout(() => this.cursor_href( [
      document.getElementsByClassName('min')[0],
      document.getElementsByClassName('selfdescription')[0],
      document.getElementsByClassName('projects')[0],
      document.getElementsByClassName('link')[0],
      document.getElementsByClassName('go_next')[0],
      //document.getElementsByClassName('g')[0],
      //document.getElementsByClassName('settings')[0],
      document.getElementsByClassName('item')[0],
      document.getElementsByClassName('item')[1],
      document.getElementsByClassName('item')[2],
      document.getElementsByClassName('item')[3],
      document.getElementsByClassName('repo')[0],
      document.getElementsByClassName('repo')[1]
    ] ), 350)
    document.addEventListener("mousemove", (e) => {
        let x = e.clientX-13;
        let y = e.clientY-13;
        cursor.style.left = x + "px";
        cursor.style.top = y + "px";
    })
  },
  methods: {
      cursor_href: (elements) => {
        for (const element of elements) {
          element.addEventListener('mouseenter', () => {
            document.getElementsByClassName('cursor')[0].classList.add('hyperstatus')
            document.getElementsByClassName('dot')[0].classList.add('hyperdot')
          })
          element.addEventListener('mouseleave', () => {
            document.getElementsByClassName('cursor')[0].classList.remove('hyperstatus')
            document.getElementsByClassName('dot')[0].classList.remove('hyperdot')
          })
        }
      }
  }
}
</script>

<style>
.cursor-inactive {
  display: none;
}
.cursor {
  position: fixed;
  height: 43px;
  width: 43px;
  background-color: #23232340;
  backdrop-filter: blur(10px);
  border: 3px solid #252525;
  border-radius: 50%;
  transform: scale(1) translate(-9px, -9px);
  box-shadow: 0px 5px 10px rgba(29, 29, 29, 0.397);
  z-index: 999;
  pointer-events: none;
  animation: remove 0.22s;
}

.dot {
  position: fixed;
  width: 13%;
  height: 13%;
  background-color: rgb(255, 255, 255);
  top: 50%; right: 50%;
  transform: translate(50%,-50%);
  border-radius: 50%;
  z-index: 998;
}

.hyperstatus {
  position: fixed;
  transform: scale(1.5) translate(-9px, -9px);
  background-color: inherit;
  border: none;
  box-shadow: none;
  backdrop-filter: invert(100%) saturate(120%) contrast(150%) brightness(1.1); /* CUSTOM CURSOR: hue-rotate(300deg) */
  animation: become 0.22s;
}
/*
.hyperstatus:after {
  content: 'About me';
  text-align: center;
  width: 300%;
  position: absolute;
  top: 110%;
  left: -100%;
  right: 100%;
  font-size: 16px;
  font-family: 'Roboto';
  font-weight: 600;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.632);
} */

@keyframes become {
  from {
    transform: scale(1) translate(-9px, -9px);
  }
  to {
    transform: scale(1.5) translate(-9px, -9px);
  }
}

@keyframes remove {
  from {
    transform: scale(1.5) translate(-9px, -9px);
  }
  to {
    transform: scale(1) translate(-9px, -9px);
  }
}

.hyperdot {
  background-color: rgb(0, 0, 0);
  text-decoration: none;
}
</style>